import { render, staticRenderFns } from "./Craft.vue?vue&type=template&id=c5736baa&"
import script from "./Craft.vue?vue&type=script&lang=js&"
export * from "./Craft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports